export const accordionFragment = `
  fragment accordionFragment on AccordionRecord {
    button {
      ...buttonFragment
    }
    cards {
      ...accordionCardFragment
    }
    description {
      blocks
      links
      value
    }
    moduleFormat {
      ...moduleFormatFragment
    }
    title
  }

  fragment accordionCardFragment on AccordionCardRecord {
    horizontalButtonImage: buttonImage {
      responsiveImage(
        imgixParams: {
          auto: format
          cornerRadius: "54"
          crop: focalpoint
          fit: crop
          h: 141
          mask: corners
          q: 45
          w: 735
        }
      ) {
        ...responsiveImageFragment
      }
    }
    verticalButtonImage: buttonImage {
      responsiveImage(
        imgixParams: {
          auto: format
          cornerRadius: "24"
          crop: focalpoint
          fit: crop
          h: 321
          mask: corners
          q: 45
          w: 82
        }
      ) {
        ...responsiveImageFragment
      }
    }
    id
    description {
      blocks
      links
      value
    }
    logoListBackground {
      backgroundColor
    }
    logos {
      id
      responsiveImage(
        imgixParams: {
          auto: format
          cornerRadius: "8"
          fit: clip
          h: 40
          mask: corners
          q: 45
          w: 40
        }
      ) {
        ...responsiveImageFragment
      }
    }
    title
  }
`;
